import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchSupportMessages,
  markAsReadByAdmin,
} from "../../../features/supportChat/supportChatSlice";
import ChatMessage from "../chatMessage/ChatMessage";
import MessageThread from "../messageThread/MessageThread";

const EMPTY = [];

// The player's messages carry their populated senderId; support's are null.
const sideOf = (message) => (message.senderId ? "player" : "support");

// One support chat's messages (keyed by chatId by its parent, so each chat
// starts fresh): shows what's cached at once and refreshes the newest page;
// marks the player's messages read once they're on screen.
const ChatContainer = ({ chatId }) => {
  const dispatch = useDispatch();
  const timeZone = useSelector((state) => state.timeZone.timeZone);
  const thread = useSelector((state) => state.supportChat.messages[chatId]);
  const unread = useSelector(
    (state) =>
      state.supportChat.chats.find((chat) => chat._id === chatId)?.unreadByAdminCount || 0,
  );

  const loadNewest = useCallback(
    () => dispatch(fetchSupportMessages({ chatId })),
    [dispatch, chatId],
  );
  const loadOlder = useCallback(
    (oldest) => dispatch(fetchSupportMessages({ chatId, beforeId: oldest._id })),
    [dispatch, chatId],
  );
  const markSeen = useCallback(() => dispatch(markAsReadByAdmin(chatId)), [dispatch, chatId]);

  useEffect(() => {
    loadNewest();
  }, [loadNewest]);

  const renderMessage = useCallback(
    ({ message, side, groupStart, groupEnd }) => (
      <ChatMessage
        message={message}
        chatId={chatId}
        side={side}
        groupStart={groupStart}
        groupEnd={groupEnd}
        timeZone={timeZone}
      />
    ),
    [chatId, timeZone],
  );

  return (
    <MessageThread
      items={thread?.items || EMPTY}
      status={thread?.status || "idle"}
      olderStatus={thread?.olderStatus || "idle"}
      hasMore={Boolean(thread?.hasMore)}
      unread={unread}
      timeZone={timeZone}
      sideOf={sideOf}
      renderMessage={renderMessage}
      onLoadNewest={loadNewest}
      onLoadOlder={loadOlder}
      onSeen={markSeen}
      emptyText="ابدأ المحادثة برسالة من الأسفل."
    />
  );
};

export default ChatContainer;
